import script from "./ControlPanelCollapse.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlPanelCollapse.vue?vue&type=script&setup=true&lang=ts"

import "./ControlPanelCollapse.vue?vue&type=style&index=0&id=2dd62e8c&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dd62e8c"]])

export default __exports__